import React from "react";
import { Col, Row } from "react-bootstrap";
import BusinessTypeOptionCard from "./BusinessTypeOptionCard";
import { BusinessTypeOption } from "./BusinessTypeOptions";
import { BusinessType } from "./businessType";

interface BusinessTypeSelectorProps {
    name?: string;
    title?: string;
    selectedBusinessType: BusinessType;
    options: BusinessTypeOption[];
    onChange: (businessType: BusinessType) => void;
    disabled?: boolean;
}

const BusinessTypeSelector: React.FC<BusinessTypeSelectorProps> = ({
    name = "businessType",
    title,
    selectedBusinessType,
    options,
    onChange,
    disabled = false,
}) => {
    return (
        <fieldset className="border-0 p-0 m-0">
            {title ? <h5 className="fs-4 mb-4">{title}</h5> : null}
            <Row className="d-flex flex-column gap-4">
                {options.map((businessTypeOption) => (
                    <Col xs={12} key={businessTypeOption.value}>
                        <BusinessTypeOptionCard
                            inputId={`${name}-${businessTypeOption.value}-field`}
                            name={name}
                            value={businessTypeOption.value}
                            label={businessTypeOption.label}
                            description={businessTypeOption.description}
                            icon={businessTypeOption.icon}
                            checked={selectedBusinessType === businessTypeOption.value}
                            disabled={disabled}
                            onChange={(value) => onChange(value as BusinessType)}
                        />
                    </Col>
                ))}
            </Row>
        </fieldset>
    );
};

export default React.memo(BusinessTypeSelector);
